import { Form } from "@unform/web";
import { useState } from "react";

import { locations } from "Helpers/Locations";
import { MISSING_CITY_MESSAGE } from "Helpers/RealizationAddress";

import Button from "Components/Global/Buttons";
import AsyncSelect from "Components/Global/Form/AsyncSelect";
import Select from "Components/Global/Form/Select";

import * as S from "./styles";

/**
 * Modal de "Locais de Realização", compartilhado por duas telas com regras
 * DIFERENTES:
 * - cadastro/edição de PROJETO: cidade obrigatória (`requireCity`);
 * - formulário da SELETIVA (/admin/seletivas): UF sozinha = "todo o estado", e
 *   por isso a exigência é opt-in e o default é falso.
 */
const RealizationAddress = ({
  currentUf,
  setCurrentUf,
  setModalOpen,
  onSubmit,
  variant = "dark",
  requireCity = false,
}) => {
  const [error, setError] = useState("");

  const ufs = locations.states.map((state) => ({
    label: state.name,
    value: state.uf,
  }));

  const filteredUf = currentUf
    ? locations.states.find((state) => state.uf === currentUf.value)
    : [];

  const filteredCityOptions = currentUf
    ? filteredUf.cities.map((city) => ({
        label: city,
        value: city,
        state: city,
      }))
    : [];

  const filterCities = (inputValue) => {
    return filteredCityOptions.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase()),
    );
  };

  const loadOptions = (inputValue, callback) => {
    callback(filterCities(inputValue));
  };

  return (
    <Form
      onSubmit={(data) => {
        // Em projeto, toda UF precisa de ao menos uma cidade (o backend recusa o
        // contrário). Sem esta guarda, `cities` chegava nulo e o spread do
        // chamador estourava um TypeError silencioso no console.
        if (requireCity && !data?.cities?.length) {
          setError(MISSING_CITY_MESSAGE);
          return;
        }

        setError("");
        onSubmit(data.cities);
      }}
    >
      <S.Wrapper>
        <Select
          name="uf"
          label="UF"
          placeholder="Selecione uma UF"
          options={ufs}
          onChange={(e) => {
            if (!e?.value) return;
            setCurrentUf(e);
          }}
          value={currentUf}
          maxWidth={"100%"}
          variant={variant}
        />

        {currentUf && (
          <AsyncSelect
            name="cities"
            label="Cidade(s)"
            placeholder="Selecione uma Cidade"
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions
            maxWidth={"100%"}
            isMulti
            variant={variant}
          />
        )}
      </S.Wrapper>

      {error && (
        <S.Error role="alert" variant={variant}>
          {error}
        </S.Error>
      )}

      <S.ModalButtons>
        <Button
          type="button"
          outline
          text="Cancelar"
          onClick={() => setModalOpen(null)}
        />
        <Button type="submit" text="Enviar" />
      </S.ModalButtons>
    </Form>
  );
};

export default RealizationAddress;
